import { render, staticRenderFns } from "./BankListView.vue?vue&type=template&id=5371bd4c&"
import script from "./BankListView.vue?vue&type=script&lang=ts&"
export * from "./BankListView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports